<template>
  <div class="auth-page__bg">
    <div class="auth-page__wrapper">
      <div class="auth-page__form">
        <form class="auth-page__inputs" @submit.prevent="dispatchLogin">
          <h3>Admin-Login</h3>
          <hr />
          <input
            type="email"
            placeholder="Email"
            v-model="payload.email"
            @enter="dispatchLogin"
          />
          <input
            type="password"
            placeholder="Password"
            v-model="payload.password"
            @enter="dispatchLogin"
          />
          <button class="auth-page__button" @click="dispatchLogin">
            Login
          </button>
          <router-link class="text-xl mt-2 text-red-900" :to="{ name: 'Home' }"
            >Zurück</router-link
          >
        </form>
        <div class="auth-page__image">
          <img src="../../assets/images/login_image.jpeg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payload: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    async dispatchLogin() {
      await this.$store.dispatch('registerApplication')
      await this.$store
        .dispatch('login', this.payload)
        .then(() => {
          this.$router.push({
            name: 'Portal'
          })
        })
        .catch(error => {
          console.log(error.data)
        })
    }
  }
}
</script>

<style lang="sass">
.auth-page
  &__bg
    background: url(../../assets/images/login_background.jpeg)
    @apply h-screen w-full bg-cover bg-no-repeat bg-center
  &__wrapper
    @apply flex justify-center items-center h-full w-full px-4
  &__form
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2)
    transition: 0.2s ease-in
    @apply bg-white w-full flex flex-col
    &:hover
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2)
  &__inputs
    @apply px-4 py-4 flex flex-col
    input
      background: #e0eaf4
      @apply w-full px-2 my-2 rounded-md
  &__button
    background: #fff
    color: $accent-color
    border: 1px solid $accent-color
    transition: all 0.2s ease-in
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2)
    @apply w-1/2 rounded-md mt-2
    &:hover
      background: $accent-color
      color: #fff

@screen md
  .auth-page
    &__form
      @apply flex flex-row-reverse justify-center w-1/2
    &__inputs, &__image
      @apply w-1/2
    &__inputs
      @apply flex flex-col justify-center items-center
</style>
